// src/components/ui/Card.jsx
import React from "react";

export const Card = ({ children, className = "" }) => {
  return (
    <div
      className={`bg-surface text-body border border-border shadow-md rounded-2xl p-6 space-y-4 ${className}`}
    >
      {children}
    </div>
  );
};

export const CardContent = ({ children, className = "" }) => {
  return <div className={`text-body ${className}`}>{children}</div>;
};
